import React from 'react';
import cn from 'classnames';

import DefaultPreviewBase from 'assets/img/course-preview.svg';

import styles from './TrainingPreview.module.scss';

const DefaultPreview = DefaultPreviewBase as unknown as React.ComponentType<{
  className?: string;
}>;

const TrainingPreview = ({
  className,
  preview,
}: {
  className: any;
  preview: any;
}) =>
  preview ? (
    <div className={cn(styles.preview, className)}>
      <img className={styles.img} src={preview} />
    </div>
  ) : (
    <DefaultPreview className={cn(styles.preview, className)} />
  );

export default React.memo(TrainingPreview) as any;
